export const achievementData = {
    bio : "If it doesn't challenge you, it won't change you.",
    achievements : [
        {
            id : 1,
            title : 'TensorFlow Developer Certified',
            date : 'July 09, 2022',
            field : 'Cloud',
            image : 'https://i.ibb.co/PwxN0FH/TENSORFLOW-1.png'
        },
        {
            id : 2,
            title : 'Ex-183 Red Hat Application Developer',
            date : 'July 09, 2022',
            field : 'Cloud',
            image : 'https://i.ibb.co/yyHzSzC/Red-Hat-Certified-Enterprise-Application-Developer-Badge20221221-32-1nhl5bz-1.png'
        },
        {
            id : 3,
            title : 'AWS Certified Developer Associate',
            date : 'July 09, 2022',
            field : 'Cloud',
            image : 'https://i.ibb.co/nzjMYFk/aws.png'
        },
        {
            id : 4,
            title : 'Microsoft Certified DevOps Engineer Expert',
            date : 'July 12, 2022',
            field : 'DevOps',
            image : 'https://i.ibb.co/qYRG3v1/400.png'
        },
        {
            id : 5,
            title : 'Oracle Autonomous Database Cloud Specialist',
            date : 'February 10, 2022',
            field : 'Database Cloud',
            image : 'https://i.ibb.co/gwf15Gn/or.png'
        },
        {
            id : 6,
            title : 'Servicenow Certified System Administrator',
            date : 'Septempber 10, 2022',
            field : 'Database Administrator',
            image : 'https://i.ibb.co/r2zWCC0/se.png'
        },
        {
            id : 7,
            title : 'Aviatrix Certified Engineer',
            date : 'June 14, 2022',
            field : 'Cloud Networking',
            image : 'https://i.ibb.co/phRCnxp/Av.png'
        }
    ]
}